import React from 'react';
import { Link } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import SpaceMonkeyLogo from '../../components/brand/SpaceMonkeyLogo';
import './SpaceMonkeySignPage.css';

const PAY_URL = `${window.location.origin}/spacemonkey/pay`;

const SpaceMonkeySignPage = () => {
  return (
    <div className="sign-screen">
      {/* Screen-only controls (hidden when printing) */}
      <div className="sign-toolbar no-print">
        <Link to="/spacemonkey/dashboard" className="sign-back">Back to dashboard</Link>
        <button className="btn btn-primary" onClick={() => window.print()}>Print Sign</button>
      </div>

      {/* Printable sign */}
      <div className="sign-sheet">
        <div className="sign-inner">
          <div className="sign-logo">
            <SpaceMonkeyLogo size="hero" tagline={false} />
          </div>
          <div className="sign-brand">SPACE MONKEY PARKING</div>

          <div className="sign-rules">
            <p className="sign-rule">Customers park free with validation.</p>
            <p className="sign-rule">All other visitors must purchase a parking permit.</p>
          </div>

          <div className="sign-qr">
            <QRCodeCanvas value={PAY_URL} size={320} level="H" includeMargin />
          </div>

          <p className="sign-scan">Scan to pay before leaving your vehicle.</p>

          <div className="sign-powered">Powered by RGV Smart Pay</div>
        </div>
      </div>
    </div>
  );
};

export default SpaceMonkeySignPage;
